import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ABIOS_CONFIG_NAME: InjectionToken<string> = new InjectionToken<string>('AbiosConfigName');
